import { find, map, propEq } from 'ramda';

export const parse = ({ conditions, tags }) => map((tag) => {
    const { conditionIds, ...rest } = tag;

    return {
        ...rest,
        conditions: map(condId => find(propEq('conditionId', condId))(conditions))(conditionIds)
    };
})(tags);
